import { Component, input } from '@angular/core';

import { getStatusColor } from '../../../../lib/functions';
import { LegendCategory } from './leaflet-legend.types';

export * from './leaflet-legend.types';

@Component({
  selector: 'app-leaflet-legend',
  standalone: true,
  styleUrls: ['./leaflet-legend.component.scss'],
  template: `
    <div class="legend-container">
      <strong>Legend</strong>
      @for (cat of categories(); track cat.label) {
        <div class="legend-item">
          <i
            class="legend-icon"
            [style.background-color]="getStatusColor(cat.label)"
          >
            {{ cat.count }}
          </i>
          {{ cat.label }}
        </div>
      }
    </div>
  `,
})
export class LeafletLegendComponent {
  readonly categories = input<LegendCategory[]>([]);

  readonly getStatusColor = getStatusColor;
}
